import React, { Component } from 'react';

import PureRenderMixin from 'react-addons-pure-render-mixin';

export interface TextAreaFieldProps {
  text: string;
  height: number;
  width: number;
  fontName?: string;
  fontSize?: number;
  lineHeight?: number;
  foregroundColor?: string;
  foregroundColorOpacity?: number;
  align?: string;
  disablePointerEvents?: boolean;
  padding?: number;
}

export default class TextAreaField extends Component<TextAreaFieldProps> {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }

  render() {
    const style = {
      fontFamily: this.props.fontName,
      fontSize: `${this.props.fontSize || 16}px`,
      color: this.props.foregroundColor,
      opacity: this.props.foregroundColorOpacity,
      width: this.props.width,
      height: this.props.height,
      textAlign: this.props.align || 'left',
      overflow: 'hidden',
      position: 'static',
      background: 'transparent',
      resize: 'none',
      outline: 'none',
      lineHeight: this.props.lineHeight ? `${this.props.lineHeight}px` : 'initial'
    };

    return (
      <foreignObject
        xmlns="http://www.w3.org/1999/xhtml"
        width={this.props.width}
        height={this.props.height}
        style={{ pointerEvents: this.props.disablePointerEvents ? 'none' : 'auto' }}
      >
        <textarea readOnly style={style as any} value={this.props.text} />
      </foreignObject>
    );
  }
}
